/* global Plyr */

export default class VideoPlayer {
  constructor($element) {
    this.plyr = Plyr.setup($element);
  }

  unmount() {
    this.plyr.destroy();
  }
}
